import { IDotXetHocVuUpdateTrangThaiRequest } from "../../model/request/xet-hoc-vu/IDotXetHocVuUpdateTrangThaiRequest";
import { IDotXetHocVu } from "../../model/response/xet-hoc-vu/IDotXetHocVu";
import { apiClient } from "../apiClient";

export const DOT_XET_HOC_VU_ENDPOINT = "dot-xet-hoc-vu";
export const dotXetHocVuApi = {
    SelectAll: () => apiClient.get(`${DOT_XET_HOC_VU_ENDPOINT}`),
    Insert: (data: IDotXetHocVu) => apiClient.post(`${DOT_XET_HOC_VU_ENDPOINT}`, data),
    Update: (id: number, data: IDotXetHocVu) => apiClient.put(`${DOT_XET_HOC_VU_ENDPOINT}/${id}`, data),
    Delete: (id: number) => apiClient.delete(`${DOT_XET_HOC_VU_ENDPOINT}/${id}`),
    UpdateTrangThai: (id: number, data: IDotXetHocVuUpdateTrangThaiRequest) => apiClient.patch(`${DOT_XET_HOC_VU_ENDPOINT}/${id}/trang-thai`,data),
}